import React, {FC} from 'react';
import {connect} from 'react-redux';
import BrandsTobacco from '../../components/BrandsTobacco';
import {handleBrandsId, sendUserPreferences} from "../../modules/Preferences";
import {IBrands} from "../../constants/types";

interface IBrandsTobaccoPage {
    sendUserPreferences: any,
    handleBrandsId: any,
    activeBrandsId: Array<number>,
    activeHardnessId: number,
    brands: Array<IBrands>
}

const BrandsTobaccoPage: FC<IBrandsTobaccoPage> = ({
                                                       sendUserPreferences,
                                                       handleBrandsId,
                                                       activeBrandsId,
                                                       activeHardnessId,
                                                       brands
                                                   }) => {
    return (
        <BrandsTobacco
            sendUserPreferences={sendUserPreferences}
            activeBrandsId={activeBrandsId}
            handleBrandsId={handleBrandsId}
            brands={brands}
            activeHardnessId={activeHardnessId}
            withoutBackButton
        />
    )
};

const mapStateToProps = (state: any) => ({
    brands: state.system.brands,
    activeBrandsId: state.preferences.activeBrandsId,
    activeHardnessId: state.preferences.activeHardnessId,
});

const mapDispatchToProps = (dispatch: any) => ({
    handleBrandsId: (id: number) => dispatch(handleBrandsId(id)),
    sendUserPreferences: () => dispatch(sendUserPreferences())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BrandsTobaccoPage);
